import { PasswordCriteria } from './password-criteria.model';

export class PasswordState {
  isValid: boolean;
  value: string;
  validSecondaryCriteriesCounter: number;
  criteriaDiscretes: Map<PasswordCriteria, boolean>;

  constructor() {
    this.validSecondaryCriteriesCounter = 0;

    this.criteriaDiscretes = new Map<PasswordCriteria, boolean>();
    this.criteriaDiscretes[PasswordCriteria.Number] = false;
    this.criteriaDiscretes[PasswordCriteria.UpperCase] = false;
    this.criteriaDiscretes[PasswordCriteria.LowerCase] = false;
    this.criteriaDiscretes[PasswordCriteria.SpecialSymbol] = false;
  }
}
